// DetalleEmpleadoContacto.jsx
import React from "react";
import "./detalleEmpleadoContacto.css"

export default function DetalleEmpleadoContacto({ contactosEmergencia = [] }) {
  return (
    <div className="mb-4 detalle-empleado-contacto">
      <h5 className="mb-2">Contacto de Emergencia</h5>
      {Array.isArray(contactosEmergencia) && contactosEmergencia.length > 0 ? (
        contactosEmergencia.map((contacto, index) => (
          <div key={index} className="contacto-card">
  <div className="header">
    <p className="titulo">{contacto.nombre || "-"}</p>
    <div className="badge-parentesco">{contacto.parentesco || "-"}</div>
  </div>
  <div className="contacto-details">
    <div className="contacto-item phone">
      <strong>Teléfono:</strong> {contacto.telefono || <span className="fallback">-</span>}
    </div>
    <div className="contacto-item phone-alt">
      <strong>Alterno:</strong> {contacto.telefonoAlterno || <span className="fallback">-</span>}
    </div>
    <div className="contacto-item address">
      <strong>Dirección:</strong> {contacto.direccion || <span className="fallback">-</span>}
    </div>
  </div>
</div>

        ))
      ) : (
        <div className="text-muted">No hay contactos de emergencia registrados.</div>
      )}
    </div>
  );
}
